import type { LayoutHandleProps } from '#/layouts/Layout/LayoutHandleProps';
import { searchVolopsRoutePathByLocale } from '#/modules/search/routing/search.route-paths';
import type { searchVolopsRouteReference } from '#/modules/search/routing/search.routes';
import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from '#/routing/types/HorizonAppRouteComponentProps';

import { SearchVolopsPageLoadable } from './SearchVolopsPageLoadable';

export const handle = {
  urlByLocale: searchVolopsRoutePathByLocale,
  darkBackground: true,
  defaultSearchType: 'VOLOP',
  hideFooterDivider: true,
  showDesktopSearch: true,
  searchFromPageType: 'SEARCH',
  showSearchRefinements: true,
  isSearchPage: true,
} satisfies LayoutHandleProps;

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof searchVolopsRouteReference>,
) {
  await SearchVolopsPageLoadable.load();
}

export default function SearchVolopsHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <SearchVolopsPageLoadable />;
}
